import { Loader2 } from "lucide-react";

type Props = {
  icon?: React.ReactNode;
  title: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
};

export default function PaymentMethodButton({
  icon,
  title,
  onClick,
  disabled,
  loading,
}: Props) {
  return (
    <button
      onClick={loading ? undefined : onClick}
      className="relative flex items-center justify-between bg-[--color-background-secondary] rounded-xl p-2 pt-2.5 w-full group disabled:cursor-not-allowed disabled:opacity-50 hover:opacity-70 transition-opacity"
      disabled={loading ? false : disabled}
    >
      <div className="flex flex-col gap-1.5 items-center w-full">
        {icon}
        <div className="text-start flex-1">
          <div className="flex justify-between items-center">
            <div className="font-medium text-xs text-[--color-text-primary]">
              {title}
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="absolute inset-0 flex items-center justify-center bg-[--color-background-secondary] opacity-80 rounded-xl">
          <Loader2 className="h-5 w-5 animate-spin text-[--color-text-secondary]" />
        </div>
      ) : null}
    </button>
  );
}
